import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Amplify } from "aws-amplify";
import "./adapters/i18n/i18n.config"; // Initialize i18n before rendering
import { amplifyConfig } from "./config/amplify.config";
import { store, persistor } from "./store";
import { Web3AuthProvider } from "./adapters/web3auth/Web3AuthProvider";
import App from "./App.tsx";
import "./styles/index.css";

// Initialize AWS Amplify
Amplify.configure(amplifyConfig);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Web3AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Web3AuthProvider>
      </PersistGate>
    </Provider>
  </StrictMode>
);
